import styled from 'styled-components';
import theme from '../../theme';

const Avatar = ({
  username,
}) => {
  const initials = () => {
    if (username) return `${username[0].toUpperCase()}${username[1].toUpperCase()}`
    return ''
  }

  return <Container>
    <Initials>
      {initials()}
    </Initials>
  </Container>
}

export default Avatar;

const Container = styled.div`
  width: 36px;
  height: 36px;
  border-radius: ${theme.radii.full};
  background: ${theme.colors.accentTealBg};
  color: ${theme.colors.accentTeal};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Initials = styled.span`
  font-family: ${theme.fontFamily};
  font-weight: ${theme.fontWeights.bold};
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.16px;
`
